import React from 'react';

import { sanitizeHtml } from '../../helpers/format';

const SafeHtml = ({ originalHtml, ...props }) => (
  <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(originalHtml) }} {...props} />
);

export default SafeHtml;
